'use client';

import { createContext } from 'react';

export interface SheetPresentation {
  disableAnimations: boolean;
  contentKey: string;
  direction: 'next' | 'previous' | null;
  initialTab?: string;
  onTabChange: (tab: string) => void;
}

export interface SheetContextValue {
  canNavigateBack: boolean;
  navigateBack: () => void;
  presentation?: SheetPresentation;
}

// Provided by the factory's SheetRenderer so descendants (e.g. SheetNavigationHeader)
// can resolve back-navigation without each sheet threading the callback down as a prop.
// `null` when rendered outside a SheetRenderer — consumers treat as "no back-nav available".
export const SheetContext = createContext<SheetContextValue | null>(null);
